/**
 * validates UK postcodes are correct format
 * https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
 */
const validateUKPostcode = (postCodeToValidate) => {
    const postcodeRegex = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/gm;
    const isValid = postcodeRegex.test(postCodeToValidate);
    return isValid;
};

export default validateUKPostcode;
